import { mapState } from 'vuex';
import Vue from 'vue';
import VueGtag from 'vue-gtag';
import DateTimeTool from 'easyjs/lib/Tools/DateTime';
import Order from 'easyjs/lib/Schema/Order';
import { DeliveryType } from 'easyjs/lib/Schema/Delivery';
import { ExceptionCode } from 'easyjs/lib/Exceptions/ExceptionCode';
import Builder from 'easyjs/lib/Schema/Components/Builder';
import store from '@/store';
import router from '@/router';
import Menu from '@/components/_Template/Menu';
import Header from '@/components/_Template/Header';
import Footer from '@/components/_Template/Footer';
import Alert from '@/components/Alert';
import Drawer from '@/components/Drawer';
import NewOrder from '@/containers/NewOrder';
import Loading from '@/containers/ContentLoad';
import BaseLoading from '@/components/Loading';
import Updater from '@/containers/Updater';
import BaseButton from '@/components/Button';
import PullRefresh from '@/components/PullRefresh';

import CatalogAPI from '@/api/catalog';
import OrderAPI from '@/api/order';
import DeliveryPlatformAPI from '@/api/deliveryPlatform';
import { OrderFakeApi } from '@/api/OrderFakeApi';
import ScheduleAPI from '@/api/schedule';
import StoreAPI from '@/api/store';

import DesktopBridge from '@/plugins/desktop';
import AppBridge from '@/plugins/app';
import { Print as DesktopPrint } from '@/plugins/print';
import Storage2 from '@/plugins/storage2';
import { getXAPIEnv } from '@/plugins/account';
import OneSignalTool from '@/utils/onesignal.js';

require('./assets/css/veasy/reset.css');
require('./assets/css/veasy/grid.css');
require('./assets/css/veasy/fa.css');
require('./assets/css/veasy/help.css');
require('./assets/css/veasy/colors.css');
require('./assets/css/veasy/style.css');

Vue.use(
  VueGtag,
  {
    config: {
      id: 'UA-206072245-4',
      params: {
        send_page_view: true,
      },
    },
  },
  router
);

export default {
  // timers: {
  //   getIsOpen: { time: 10000, autostart: true, repeat: false },
  // },
  data() {
    return {
      alert: false,
      alertMsg: '',
      alertType: 'alert',
      alertCallback: null,
      alertClose: false,
      openSignal: false,
      closeSignal: false,
      newOrder: false,
      changeClass: '',
      grayscale: false,
      windowWidth: 0,
      updateType: '',
      showFooter: true,
      refuseOrder: false,
      catalog: null,
      windowTitle: 'Easy Delivery',
      soundStatus: true,
    };
  },
  async mounted() {
    this.getIsOpen();
    this.getIsMobile();
    this.getScreenWidth();
    this.getStoreConfigurations();
    this.initMarketing();
    this.setDesktopEnv();
    this.setUpdateListener();
    this.setEventListener();
    this.periodicChecks();
    this.initOneSignal();
    this.loadDeliveryPlatformConfigurations();
    window.alert = this.showAlert;
    window.confirm = this.showConfirm;
    this.$nextTick(() => {
      if (!DesktopBridge.isDesktop()) window.document.title = this.windowTitle;

      window.addEventListener('resize', () => {
        this.windowWidth = window.innerWidth;
      });
    });

    /** bluetooth */
    if (AppBridge.isApp()) {
      AppBridge.emit('getBluetoothPrinterConfigurations');
      AppBridge.listen('bluetoothConfigurations', (configurations) => {
        Storage2.set(
          'local',
          'bluetoothConfigurations',
          configurations.data.bluetoothConfigurations
        );
      });

      AppBridge.listen('keyboardDidShow', () => {
        this.showFooter = false;
      });

      AppBridge.listen('keyboardDidHide', () => {
        this.showFooter = true;
      });

      AppBridge.listen('reload', () => {
        window.location.reload();
      });

      AppBridge.listen('newOrderNotification', async ({ data }) => {
        let order = this.$refs.newOrder.aOrders.find((o) => o.id === data.id);

        if (!order) {
          const orderResponse = await OrderAPI.get(data.id);
          order = orderResponse.getData().order;
        }

        this.$refs.newOrder.aOrders.unshift(Order.fromObject(order));
      });
    }

    await CatalogAPI.catalogCatalog(true, true).then((response) => {
      this.catalog = Builder.mountSchema(response.getData({ type: 'catalog' }));
      Builder.executeOnSchema(this.catalog, function (item) {
        item.new = false;
        item.quantity = 0;
      });

      return this;
    });
  },
  methods: {
    getCategoryName(parentId) {
      const isCategoryParent = this.catalog.getItemsByParam('_id', parentId);
      // Está verificação é uma solução temporaria para a verificação do categoryName
      if (isCategoryParent.length > 0) {
        return isCategoryParent[0].name;
      }
    },
    setUpdateListener() {
      if (DesktopBridge.isDesktop()) {
        DesktopBridge.listen('update', () => {
          this.sendStoreAndSetUpdateType(true, 'update');
        });

        DesktopBridge.listen('clientUpdate', () => {
          this.sendStoreAndSetUpdateType(true, 'clientUpdate');
        });
      } else if (AppBridge.isApp()) {
        AppBridge.listen('update', () => {
          this.sendStoreAndSetUpdateType(true, 'update');
        });

        AppBridge.listen('clientUpdate', () => {
          this.sendStoreAndSetUpdateType(true, 'clientUpdate');
        });
      }
    },
    setEventListener() {
      if (DesktopBridge.isDesktop()) {
        DesktopBridge.listen('isFirstUse', () => {
          if (this.$store.state.route.name === 'login')
            router.replace({ name: 'signup' });
        });
      }
    },
    periodicChecks() {
      if (DesktopBridge.isDesktop()) {
        const today = new Date();
        const hours = today.getHours();
        const minutes = today.getMinutes();
        const periods = [2, 6, 10, 14, 18, 22];
        const oneHoursMilliseconds = 3.6 * Math.pow(10, 6);
        const twoHours = 7200000;
        let checkAftertWentyTwo;
        let nextCheck;

        // Transformar hora/minuto atual em milisegundos
        const hoursMilliseconds = hours * oneHoursMilliseconds;
        const minutesMilliseconds =
          minutes > 0 ? +(minutes * 60000) : oneHoursMilliseconds;

        const currentHoursMilliseconds =
          hoursMilliseconds + minutesMilliseconds;

        // pegar o próximo horario
        for (let i = 0; i < 6; i++) {
          if (hours === 22) {
            checkAftertWentyTwo =
              minutesMilliseconds + oneHoursMilliseconds + twoHours;
            break;
          }

          if (hours > 22) {
            checkAftertWentyTwo = minutes + twoHours;
            break;
          }

          if (hours < periods[i]) {
            nextCheck = periods[i];
            break;
          }
        }

        const nextCheckMillisconds = nextCheck * oneHoursMilliseconds;
        const time = nextCheckMillisconds - currentHoursMilliseconds;

        setTimeout(
          () => {
            DesktopBridge.emit('onPeriodicChecks');
            this.periodicChecks();
          },
          !time ? checkAftertWentyTwo : time
        );
      }
    },
    sendStoreAndSetUpdateType(status, updateType) {
      this.updateType = updateType;
      store.commit('store/setHasUpdate', status);
    },
    setUpdate(setOrUnset) {
      this.hasUpdate = setOrUnset;
    },
    setDesktopEnv() {
      // if (DesktopBridge.isDesktop()) {
      //   DesktopBridge.emit('openWs', customStorage().get.item('easy.account.x-api-env'))
      // }
    },
    getStoreConfigurations(loading = true) {
      const self = this;
      if (self.$store.state.route.name !== 'login') {
        this.$store.dispatch('store/getConfigurations', loading);
      }
    },
    loadDeliveryPlatformConfigurations() {
      const self = this;
      if (self.$store.state.route.name !== 'login')
        this.$store.dispatch('deliveryPlatform/loadConfigurations');
    },

    getIsOpen() {
      if (getXAPIEnv()) {
        const self = this;
        // if (self.$store.state.route.name !== 'login') {
        //   this.$store.dispatch('store/getIsOpen');
        // }
      }
    },
    getIsMobile() {
      this.$store.dispatch('store/getIsMobile');
    },
    getScreenWidth() {
      this.$store.dispatch('store/getScreenWidth');
    },
    initMarketing() {
      this.setFavIcon();
      this.setViewportMetaTag();
    },
    setFavIcon() {
      const t = document.getElementsByTagName('head')[0];
      const tfavicon = document.createElement('link');
      tfavicon.setAttribute('rel', 'shortcut icon');
      tfavicon.setAttribute('type', 'image/x-icon');
      tfavicon.setAttribute('href', `https://cdn.easydelivery.com.br/fav.png`);
      t.insertBefore(tfavicon, t.firstChild);
    },
    setViewportMetaTag() {
      const viewport = document.querySelector('meta[name=viewport]');
      viewport.setAttribute(
        'content',
        'user-scalable=no, initial-scale=1, maximum-scale=1, minimum-scale=1, width=device-width, height=device-height, target-densitydpi=device-dpi'
      );
    },
    showAlert(text, secondsToClose = null, callback) {
      this.alertMsg = text;
      this.alert = !this.alert;
      this.alertType = 'alert';
      this.alertCallback = callback;
      if (!callback) {
        const promise = new Promise((resolve) => {
          this.alertCallback = resolve;
        });

        if (!secondsToClose) {
          return promise;
        }

        const timeout = new Promise((resolve) => {
          setTimeout(() => {
            this.alertClose = !this.alertClose;
            resolve();
          }, secondsToClose * 1000);
        });

        return Promise.race([promise, timeout]);
      }
    },
    showConfirm(text, callback) {
      this.alertMsg = text;
      this.alert = !this.alert;
      this.alertType = 'confirm';
      this.alertCallback = callback;
      if (!callback) {
        return new Promise((resolve) => {
          this.alertCallback = resolve;
        });
      }
    },
    openDrawer() {
      this.order = this.$refs.newOrder.aOrders[0];
      this.openSignal = !this.openSignal;
      this.listenOrder = this.$refs.newOrder.aOrders;
    },
    closeDrawer() {
      this.closeSignal = !this.closeSignal;
    },
    onPauseStore(pauseConfigurations) {
      StoreAPI.storeConfiguration({
        status: {
          paused: new Date().toISOString(),
          ...pauseConfigurations,
        },
      });
    },
    clearOrders() {
      if (this.$refs.newOrder) {
        this.$refs.newOrder.aOrders = [];
        this.$refs.newOrder.stopVibrate();
      }
    },
    toggleSound() {
      this.soundStatus = !this.soundStatus;
      if (this.soundStatus === false) {
        this.$refs.newOrder.stopVibrate();
      } else {
        this.$refs.newOrder.startVibrate();
      }
    },

    async createOrderDelivery(order) {
      try {
        const deliveryResponse = await DeliveryPlatformAPI.postDelivery(
          this.deliveryPlatform,
          order.id
        );

        const deliveryErrors = deliveryResponse.getErrors([]);
        if (deliveryErrors.length > 0) {
          let message = `Não foi possível sincronizar este pedido: ${deliveryErrors[0]}`;

          if (
            deliveryResponse.getCode(500) ===
            ExceptionCode.FOODY_DELIVERY_ORDER_LIMIT_EXCEEDED
          ) {
            message = StringLanguage.foodyDeliveryOrderLimitExceeded;
          }

          alert(message);
        }
      } catch (err) {
        alert(err.message);
      }
    },

    async acceptOrder() {
      this.grayscale = true;
      const self = this;
      const numberOfOrders = this.$refs.newOrder.aOrders
        ? this.$refs.newOrder.aOrders.length
        : 0;
      const listenOrder = this.$refs.newOrder.aOrders[0];

      // Verificar se pedido está dentro da lista de pedidos fakes;
      if (OrderFakeApi.getLocalOrder(listenOrder.id)) {
        OrderFakeApi.accept(listenOrder.id);
        this.changeClass = 'animate__fadeOutRight';

        setTimeout(() => {
          this.changeClass = 'animate__fadeInLeft';
          this.grayscale = false;
        }, 1000);

        if (numberOfOrders == 1) {
          self.closeDrawer();
        }
        return;
      }

      const postponedSchedule = await this.getOrderPostponedSchedule(
        this.$refs.newOrder.aOrders[0].id
      );

      // Se o pedido não foi adiado, deve-se prosseguir com a ação
      if (!postponedSchedule) {
        OrderAPI.accept(this.$refs.newOrder.aOrders[0].id).then(
          async (response) => {
            const errors = response.getErrors([]);
            const hasErrors = errors.length > 0;
            if (hasErrors) {
              alert(StringLanguage.orderAlreadyClosed);
            }

            const order = JSON.parse(JSON.stringify(listenOrder));

            const hasAddressDelivery =
              order.delivery.type === DeliveryType.DELIVER_ON_ADDRESS;
            if (
              !hasErrors &&
              this.hasActiveDeliveryPlatform &&
              hasAddressDelivery
            ) {
              await this.createOrderDelivery(order);
            }

            order.created_at =
              order.created_at ||
              response.getData({ created_at: '' }).created_at;

            order.cart.catalog.items.map((item) => {
              const parentId = ['simple', 'step', 'drink'].includes(item.type)
                ? item.parent
                : item.items[0].parent;
              // Quando possivel eliminar a função getCategory para
              // usar o categoryName direto do item
              const categoryName = self.getCategoryName(parentId);
              item.categoryName = categoryName;
            });

            if (DesktopBridge.isDesktop()) {
              DesktopPrint(order, 'pedidos', 'whenAcceptingOrders');
              return;
            }
            const dataPrint = await DesktopPrint(
              order,
              'pedidos',
              'whenAcceptingOrders',
              56,
              true
            );
            AppBridge.emit('printData', dataPrint);

            if (numberOfOrders === 1) {
              self.closeDrawer();
            }
          }
        );
        this.changeClass = 'animate__fadeOutRight';

        setTimeout(() => {
          this.changeClass = 'animate__fadeInLeft';
          this.grayscale = false;
        }, 1000);
      } else {
        alert(StringLanguage.orderAlreadyPostponed);
      }
    },
    async rejectOrder() {
      this.grayscale = true;
      const self = this;
      const numberOfOrders = this.$refs.newOrder.aOrders
        ? this.$refs.newOrder.aOrders.length
        : 0;

      const postponedSchedule = await this.getOrderPostponedSchedule(
        this.$refs.newOrder.aOrders[0].id
      );

      const listenOrder = this.$refs.newOrder.aOrders[0];
      // Verificar se pedido está dentro da lista de pedidos fakes;
      if (OrderFakeApi.getLocalOrder(listenOrder.id)) {
        OrderFakeApi.reject(listenOrder.id);
        this.changeClass = 'animate__fadeOutRight';

        setTimeout(() => {
          this.changeClass = 'animate__fadeInLeft';
          this.grayscale = false;
        }, 1000);

        if (numberOfOrders == 1) {
          self.closeDrawer();
        }

        this.switchRefuse();
        return;
      }

      // Se o pedido não foi adiado, deve-se prosseguir com a ação
      if (!postponedSchedule) {
        OrderAPI.reject(this.$refs.newOrder.aOrders[0].id).then((response) => {
          const errors = response.getErrors([]);
          if (errors.length > 0) {
            alert(StringLanguage.orderAlreadyClosed);
          }

          this.changeClass = 'animate__fadeOutRight';

          setTimeout(() => {
            this.changeClass = 'animate__fadeInLeft';
            this.grayscale = false;
          }, 1000);

          if (numberOfOrders == 1) {
            self.closeDrawer();
          }

          this.switchRefuse();
        });
      } else {
        alert(StringLanguage.orderAlreadyPostponed);
      }
    },
    postponeOrder() {
      const schedule = {
        timer: 60000,
        type: 'postponedOrders',
        extraId: this.$refs.newOrder.aOrders[0].id,
        data: this.$refs.newOrder.aOrders[0],
        service: 'socket',
      };
      this.grayscale = true;

      // Cria um agendamento para o pedido aparecer novamente depois 60s
      ScheduleAPI.create(schedule).then((response) => {
        const orderId = response.getData({ id: null }).id;
        const errors = response.getErrors([]);

        if (errors.length > 0) {
          alert(StringLanguage.orderAlreadyPostponed);
        }

        // Verifica se o pedido na posição 0 é o pedido no qual já realizou a ação
        if (
          orderId &&
          String(orderId) === String(this.$refs.newOrder.aOrders[0].id)
        ) {
          this.$refs.newOrder.aOrders.splice(0, 1);
        }

        this.changeClass = 'animate__fadeOutRight';

        setTimeout(() => {
          this.changeClass = 'animate__fadeInLeft';
          this.grayscale = false;
        }, 1000);

        const numberOfOrders = this.$refs.newOrder.aOrders
          ? this.$refs.newOrder.aOrders.length
          : 0;
        if (numberOfOrders === 0) {
          this.closeDrawer();
        }

        setInterval((orderId) => {
          this.grayscale = true;
          if (
            orderId &&
            String(orderId) === String(this.$refs.newOrder.aOrders[0].id)
          ) {
            this.$refs.newOrder.aOrders.splice(0, 1);
          }

          this.changeClass = 'animate__fadeOutRight';

          setTimeout(() => {
            this.changeClass = 'animate__fadeInLeft';
            this.grayscale = false;
          }, 1000);

          const numberOfOrders = this.$refs.newOrder.aOrders
            ? this.$refs.newOrder.aOrders.length
            : 0;
          if (numberOfOrders === 0) {
            this.closeDrawer();
          }

          location.reload();
        }, 60500);
      });
    },
    async getOrderPostponedSchedule(orderId) {
      const scheduleResponse = await ScheduleAPI.getById(
        'postponedOrders',
        orderId
      );
      const schedule = scheduleResponse.getData({});

      return schedule && schedule.status === 0 ? schedule : null;
    },
    getNoTemplate(h) {
      return (
        <div>
          <router-view />
        </div>
      );
    },
    getTemplateBody(h) {
      const userName = this.oUser.name;
      return (
        <div class='h-min-100 h-max-100 bg-content'>
          <Loading
            show={this.loading}
            progress={this.loading ? this.loading * 1 : 0}
            template={!this.noTemplate}
          />

          {!this.noTemplate ? (
            <div>
              {!this.isMobile ? (
                <div>
                  <Menu
                    oUser={this.oUser}
                    isOpen={this.isOpen}
                    onPauseStore={this.onPauseStore}
                    isPaused={this.isPaused}
                  />
                </div>
              ) : (
                !!this.showFooter && (
                  <div>
                    <Footer
                      isOpen={this.isOpen}
                      userName={userName}
                      onPauseStore={this.onPauseStore}
                      isPaused={this.isPaused}
                    />
                  </div>
                )
              )}
            </div>
          ) : (
            <div></div>
          )}

          {/* <div id="content" style={`overflow-y: ${this.loading ? 'hidden' : 'scroll'}`}> */}
          <div id='content' class={this.noTemplate ? 'no-template' : ''}>
            <PullRefresh />
            <router-view />
          </div>
          {/* <vtto-footer :phones="info.phones" :about="info.about" :company_name="info.name" :email="info.email" :address="info.address"/> */}
        </div>
      );
    },
    getTemplate(h) {
      return (
        <div class='h-min-100'>
          {/* <vtto-alerts></vtto-alerts> */}
          {this.bHasTemplateBody === false
            ? this.getNoTemplate(h)
            : this.getTemplateBody(h)}
        </div>
      );
    },
    switchRefuse() {
      this.refuseOrder = !this.refuseOrder;
    },
    initOneSignal() {
      const appId = process.env.VUE_APP_ONESIGNAL_APP_ID;
      if (!AppBridge.isApp()) OneSignalTool.initialize(appId);
    },
  },
  computed: {
    ...mapState({
      // info: state => state.store.info,
      // mainMenu: state => state.store.mainMenu,
      storeConfiguration: (state) => state.store.configurations,
      isLogged: (state) => state.account.isLogged,
      loading: (state) => state.store.loading,
      oUser: (state) => state.account.oUser,
      bHasNoTemplate: (state) => state.route.meta.bHasNoTemplate,
      bHasTemplateBody: (state) => state.route.meta.bHasTemplateBody,
      scrolled: (state) => state.store.scrolled,
      isOpen: (state) => state.store.info.working_time.is_open,
      isMobile: (state) => state.store.isMobile,
      noTemplate: (state) => state.store.noTemplate,
      hasUpdate: (state) => state.store.hasUpdate,
      hasActiveDeliveryPlatform: (state) =>
        state.deliveryPlatform.tokenConfigurationIsActive,
      deliveryPlatform: (state) => state.deliveryPlatform.deliveryPlatform,
    }),
    isPaused() {
      if (!this.storeConfiguration || !this.storeConfiguration.status)
        return false;
      const { paused, interval, unit } = this.storeConfiguration.status;
      if (!paused || !interval || !unit) {
        return false;
      }
      return (
        new Date().getTime() <
        DateTimeTool.addTime(new Date(paused), interval, +unit)
      );
    },
  },
  watch: {
    windowWidth(newWidth, oldWidth) {
      const menu = document.getElementsByClassName('window-icon-bg');
      const maximize = document.querySelector(
        '.window-icon-bg .window-icon.window-max-restore'
      );

      menu[0].removeAttribute('title');
      menu[2].removeAttribute('title');
      maximize.removeAttribute('title');

      this.getIsMobile();
      this.getScreenWidth();
    },
  },
  render(h) {
    if (this.isLogged) AppBridge.emit('onUnlockOrientation');

    return (
      <div id='app' ref='app'>
        {this.bHasNoTemplate === true
          ? this.getNoTemplate(h)
          : this.getTemplate(h)}

        {/* Drawer novo pedido */}
        <Drawer
          open={this.openSignal}
          close={this.closeSignal}
          title={`Novo Pedido! (#${this.order ? this.order.order_id : ''})`}
          direction={this.isMobile ? 'top' : 'left'}
          time={this.isLogged && this.order ? '.3' : 0}
          zIndex='2501'
          drawerNewOrder
          overflow='hidden'
          onOnClose={() => {
            this.soundStatus = true;
            this.clearOrders();
          }}
          haveX={false}
          closeInFade={false}
        >
          <NewOrder
            ref='newOrder'
            changeClass={this.changeClass}
            onDrawerOpen={this.openDrawer.bind(this)}
            onDrawerClose={this.closeDrawer.bind(this)}
            enabledSound={this.soundStatus}
          />

          <template slot='footer'>
            {this.refuseOrder ? (
              <div>
                <p
                  class='text-center w-100 mb_25 mt_10 fs-14 fw-400'
                  style='color: #999'
                >
                  Tem certeza que deseja recusar este pedido?
                </p>
                <div class='d-flex'>
                  <BaseButton
                    onClick={this.rejectOrder}
                    text='Recusar'
                    design='four'
                    class='w-100 mr_7'
                  />
                  <BaseButton
                    onClick={this.switchRefuse}
                    text='Cancelar'
                    class='w-100 ml_7'
                  />
                </div>
              </div>
            ) : (
              <div>
                {!this.grayscale ? (
                  <div class='d-flex'>
                    <BaseButton
                      onClick={this.switchRefuse}
                      design='four'
                      class='mr_15'
                      title='Recusar pedido'
                      style='flex: 0 52px; color: #8C8C8C'
                    >
                      <i class='fal fa-times' style='font-size: 18px'></i>
                    </BaseButton>
                    {/* <BaseButton
                      onClick={this.postponeOrder}
                      design='four'
                      class='mr_15'
                      title='Adiar decisão'
                      style='flex: 0 52px; color: #8C8C8C'
                    >
                      <i class='fal fa-clock' style='font-size: 18px'></i>
                    </BaseButton> */}
                    <BaseButton
                      onClick={this.toggleSound}
                      title={this.soundStatus ? 'Desativar som' : 'Ativar som'}
                      class='w-100 flex'
                      design='four'
                      class='mr_15'
                      style='flex: 0 52px; color: #8C8C8C'
                    >
                      {this.soundStatus ? (
                        <i class='fal fa-volume' style='font-size: 18px' />
                      ) : (
                        <i class='fal fa-volume-mute' style='font-size: 18px' />
                      )}
                    </BaseButton>
                    <BaseButton
                      onClick={this.acceptOrder}
                      text='Aceitar pedido'
                      class='w-100 flex'
                    />
                  </div>
                ) : (
                  <div class='d-flex justify-center' style='padding: 16px 0'>
                    <BaseLoading color='#FF3382' />
                  </div>
                )}
              </div>
            )}
          </template>
        </Drawer>

        {/* Apenas para dev */}
        {/* <button onClick={(() => this.newOrder = !this.newOrder).bind(this)} class="fixed top-0 left-0 py_15">Novo pedido</button> */}

        {/* Alerta */}
        <Drawer
          open={this.alert}
          close={this.alertClose}
          title='Atenção'
          direction='bottom'
          height='auto'
          zIndex='3000'
          time='0.3'
          overflow='hidden'
          haveX={false}
        >
          <Alert
            msg={this.alertMsg}
            type={this.alertType}
            cb={this.alertCallback}
            onCloseAlert={() => (this.alertClose = !this.alertClose)}
          />
        </Drawer>

        {/* Atualização */}
        {this.hasUpdate && (
          <Updater
            onSetUpdate={this.setUpdate.bind(this)}
            updateType={this.updateType}
          />
        )}
      </div>
    );
  },
};
